import classNames from "classnames";
import s from "./THead.module.scss";

type Props = {
  className?: string;
};

const THead: React.FC<Props> = ({ children, className }) => (
  <thead className={classNames(s.sticky, className)}>
    {children}
  </thead>
);

export default THead;
